export * from './onOpenExternalLink';
//# sourceMappingURL=index.js.map